module.exports = __webpack_public_path__ + "img/20180815_151844_205.957d6ca9.jpg";